import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animation-intro',
  templateUrl: './animation-intro.component.html',
  styleUrls: ['./animation-intro.component.scss']
})
export class AnimationIntroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
